import { getCookie } from "cookies-next";
import client from "../client";

export interface UfabetGetBalanceResponse {
  status?: "success" | "error";
  message?: string;
  data?: {
    member_id?: number;
    ufabet_username?: string;
    balance?: number;
  };
}

/**
 * API สำหรับดึง balance ของสมาชิก ใน UFABET
 * Route: ufabet/member/balance
 * Method: GET
 * @returns Promise<UfabetGetBalanceResponse>
 *
 * @example
 * const response = await ufabetGetBalance();
 * if (response.status === 'success') {
 *   console.log('UFABET Balance:', response.data?.balance);
 * }
 */
export default async function ufabetGetBalance(): Promise<
  UfabetGetBalanceResponse | undefined
> {
  try {
    const response = await client.get<UfabetGetBalanceResponse>(
      "/ufabet/member/balance",
      {
        headers: {
          Authorization: `Bearer ${getCookie("access_token")?.toString()}`,
        },
      }
    );

    return response.data;
  } catch (error: any) {
    return {
      status: "error",
      message: error.response?.data?.message || "ไม่สามารถดึง balance ได้",
    };
  }
}
